<template>
  <div class="user">
    <div class="photo">
      <img src="static/img/faces/face-1.jpg" alt="user avatar"/>
    </div>
    <div class="info">
      <a data-toggle="collapse" :aria-expanded="!isClosed" @click="toggleMenu" href="#">
         <span>
           {{user}}
           <b class="caret"></b>
        </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <collapse-transition>
          <ul class="nav nav-menu" v-show="!isClosed">
            <li>
              <a @click="logout">
                <span class="sidebar-mini-icon">L</span>
                <span class="sidebar-normal">Logout</span>
              </a>
            </li>
            <li>
              <a @click="changePassword">
                <span class="sidebar-mini-icon">C</span>
                <span class="sidebar-normal">Change Password</span>
              </a>
            </li>
          </ul>
        </collapse-transition>
      </div>
    </div>
    <ChangePassword>
      
    </ChangePassword>
  </div>
</template>
<script>
  // const swal = require('sweetalert2')
  import { CollapseTransition } from 'vue2-transitions'
  import ChangePassword from './ChangePassword.vue'

  export default {
    components: {
      CollapseTransition,
      ChangePassword
    },
    data() {
      return {
        isClosed: true,
        user: ''
      }
    },
    created() {
      this.$data.user = localStorage.getItem('user');
    },
    methods: {
      toggleMenu() {
        this.isClosed = !this.isClosed
      },
      logout() {
        localStorage.clear();
        this.$router.push('/login');
      },
      changePassword() {
        const that = this;
        document.getElementById('change-password').style.display='block';
      }
    }
  }
</script>
<style scoped>
  .nav.nav-menu {
    margin-top: 0;
  }
</style>
